<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { useProductStore } from '~/store/product/productStore';
import CustomPicture from '~/components/pictures/custom-picture.vue';
import { VueImageZoomer } from 'vue-image-zoomer/dist/vue-image-zoomer.es';
import { MODAL_PRODUCT_VISUALIZER } from '~/store/modalStore';

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)

const productStore = useProductStore();
const {
  product,
  photoClickIndex,
  images
} = storeToRefs(productStore);

const currentSlide = photoClickIndex;
const maxImages = ref(5);
const slideTo = (val: number) => currentSlide.value = val;

const breakpointsNav = {
  320: {
    itemsToShow: 2,
    snapAlign: 'start',
    wrapAround: false,
  },
  1024: {
    itemsToShow:  5.5,
    snapAlign: 'start',
    wrapAround: false,
  },
}


const imageLength = computed(() => {
  let length = images.value.length;

  if (product.value.productVideo) {
    length = length < maxImages.value ? length + 1 : length;
  }

  return length
})


const breakpointCarousel = {
  320: {
    wrapAround: false,
    itemsToShow: 1,
    snapAlign: 'start',
    mouseDrag: false,
    touchDrag: false,
  },
  1024: {
    touchDrag: true,
    wrapAround: false,
    itemsToShow: 1,
    snapAlign: 'start'
  },
}

</script>

<template>
  <modal
:id="MODAL_PRODUCT_VISUALIZER"
         :is-visible="isModalVisible"
         classes="modal--fullscreen"
         @close="closeModal">
    <div class="product-visualizer__main-v2 img-holder">
      <carousel
                id="gallery"
                v-model="currentSlide"
                :breakpoints="breakpointCarousel">
        <slide v-for="(i, index) in imageLength" :key="index">
          <div>
            <div v-if="product.productVideo?.position !== i">
              <vue-image-zoomer
                  :regular="images[index].imageJPG2X"
                  img-class="zoom-image"
                  :show-message="false"
                  :show-message-touch="false"
                  :zoom="images[index].imageZoom"
                  :regular-webp="images[index].imageWEBP2X"
                  :zoom-webp="images[index].imageZoom"
              />
            </div>
            <div v-else>
              <video class="zoom-image" autoplay playsinline muted loop>
                <source :src="product.productVideo.url" :type="product.productVideo.mimeType">
              </video>
            </div>
          </div>
        </slide>
      </carousel>

      <carousel
          id="thumbnails"
          ref="carousel"
          :breakpoints="breakpointsNav"
      >
        <slide v-for="(i, index) in imageLength" :key="index">
          <div :class="`${currentSlide === index ? 'active' : ''} thumbnail-slides`" @click="slideTo(index)">
            <div v-if="product.productVideo?.position !== i">
              <custom-picture :image="images[index]" :alt="`${product.name}-${ product.name}-${images[index]}-${index}`" />
            </div>
            <div v-else>
              <video class="zoom-image" autoplay playsinline muted loop>
                <source :src="product.productVideo.url" :type="product.productVideo?.mimeType">
              </video>
            </div>
          </div>
        </slide>
        <template #addons>
          <Navigation />
        </template>
      </carousel>
    </div>
  </modal>
</template>

<style lang="scss">
.carousel {
  @media (min-width: 769px) {
    margin-top: 50px;
  }
}
.zoom-image {
  max-width: 100%;
  max-height: 280px;
}

#thumbnails {
  .carousel__next,
  .carousel__prev {
    background-color: rgba(245, 245, 245, .6);
    border-radius: 50%;
  }
}

.thumbnail-slides {
  border-radius: 8px;
  padding: 10px;

  &.active {
    border: 2px solid black;
  }

  img,
  video {
    cursor: pointer;
    max-width: 90%;
    max-height: 100px;
  }
}

.vh--image{
  max-width: none!important;
  width: auto !important;
}

.vh--none {
  border: 2px solid black;
  border-radius: 8px;

  img {
    border-radius: 0;
  }
}
</style>
